// Shopify integration configuration.
// Live store: shop.marineforceled.com. Variant IDs for the seven official
// systems live with their prices in data/pricing.ts (single source of truth).
// Checkout handoff uses Shopify cart permalinks: https://{domain}/cart/{variant}:{qty},{variant}:{qty}

export const shopifyConfig = {
  storeDomain: 'shop.marineforceled.com',
  discountMethod: 'bundle-variants' as 'automatic' | 'functions' | 'bundle-variants',
  /** Query params forwarded from the funnel to Shopify for attribution. */
  attributionParams: ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'gclid', 'ttclid'],
};

// Payment methods displayed near checkout CTAs. Must match the live
// Shopify Payments setup before launch.
export const checkoutTrust = {
  provider: 'Shopify',
  paymentMethods: ['Shop Pay', 'Apple Pay', 'Google Pay', 'Visa', 'Mastercard', 'Amex'],
  confirmed: false,
};

export const trackingConfig = {
  metaPixelId: '1240164748313404',
  gtmId: '',
  conversionsApiEndpoint: '',
};
